import accountStore from 'store/accountStore';
import { getAccessDenied } from '../getUrls';

export const suRouteGuard = (nextState, replace, callback) => {
  if (!accountStore.isSuperUser()) {
    replace(getAccessDenied());
  }
  callback();
};
